import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ImmutablePropTypes from 'react-immutable-proptypes';
import { Link } from '@bibliocommons/base-links';
import { ShelfMap } from '@bibliocommons/base-icons';
import { libraryShape } from '@bibliocommons/bc-prop-types';

import './StackMapLink.scss';

export default class StackMapLink extends React.PureComponent {
  handleClick = () => {
    const { stackMapActions, bibItem, currentLibrary, handleClick } = this.props;
    stackMapActions.openStackMap(currentLibrary.get('stackMap'), bibItem);
    if (handleClick) handleClick();
  };

  render() {
    const { bibItem, currentLibrary } = this.props;
    const stackMapSettings = currentLibrary.get('stackMap');

    const stackMapEnabled =
      stackMapSettings.get('enabled') &&
      stackMapSettings.get('supportedBranches').includes(bibItem.getIn(['branch', 'name'])) &&
      bibItem.get('collection') &&
      bibItem.get('callNumber') &&
      bibItem.getIn(['availability', 'statusType']) !== 'UNAVAILABLE';

    if (stackMapEnabled) {
      return (
        <Link
          className="cp-stack-map-link"
          href="#stack-map-display"
          dataKey="stack-map-link"
          handleClick={this.handleClick}
          preventDefault
        >
          <ShelfMap />
          <FormattedMessage id="shelf_map" />
        </Link>
      );
    }

    return null;
  }
}

StackMapLink.propTypes = {
  bibItem: ImmutablePropTypes.map.isRequired,
  currentLibrary: libraryShape.isRequired,
  stackMapActions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleClick: PropTypes.func
};
